import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import Helper from './helper';

import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

window.Swiper = Swiper;

class App {
    constructor() {
        this.init();
    }

    init() {
        this.search();
        this.menu();
        this.cookies();
        this.honeyForms();
        this.partnerSlider();
    }

    search() {
        document.querySelectorAll('[data-toggle="search"]').forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();

                document.body.classList.toggle('search-open');

                if (document.body.classList.contains('search-open')) {
                    // Focus the search input
                    let searchInput = document.querySelector('input[type="search"]');

                    if (searchInput) {
                        searchInput.focus();
                    }
                }
            });
        });
    }

    menu() {
        let observeMenu = function () {
            const navbar = document.querySelector('.main-navbar');

            // Check minimum window width
            if (window.innerWidth > 1200) {
                // Check if the menu is open
                if (document.body.classList.contains('menu-open')) {
                    // Remove menu open state
                    document.body.classList.remove('menu-open');

                    // Remove navbar collapse open state
                    navbar.querySelector('.navbar-collapse').classList.remove('show');
                }
            }
        }

        window.addEventListener('resize', Helper.debounce(function () {
            observeMenu();
        }));

        const collapse = document.querySelector('.main-navbar__navbar-collapse');

        if (collapse) {
            // Collapse show event listener
            collapse.addEventListener('show.bs.collapse', function () {
                // Hide navbar open state
                document.body.classList.add('menu-open');
            });

            // Collapse hide event listener
            collapse.addEventListener('hide.bs.collapse', function () {
                // Hide navbar open state
                document.body.classList.remove('menu-open');
            });
        }

        document.querySelectorAll('.main-navbar__dropdown-toggle').forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();

                if (window.innerWidth > 992) {
                    return false;
                }

                let navLink = this.closest('.nav-link');

                if (navLink.classList.contains('show')) {
                    // Hide the dropdown menu
                    new bootstrap.Dropdown(navLink).hide();
                }
                else {
                    // Show the dropdown menu
                    new bootstrap.Dropdown(navLink).show();
                }
            });
        })
    }

    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    /**
     * Honey pot protection for forms
     */
    honeyForms() {
        // Initialize honey pot for a single form
        const initHoneyForm = (form) => {
            // Skip if already initialized
            if (form.dataset.honeyInitialized === 'true') {
                return;
            }

            // Mark as initialized
            form.dataset.honeyInitialized = 'true';

            // Randomize delay between 4-6 seconds to be less predictable
            const delay = 4000 + Math.random() * 2000;

            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    const originalText = buttonSubmit.getAttribute('data-text');

                    if (originalText) {
                        buttonSubmit.innerHTML = originalText;
                        buttonSubmit.disabled = false;
                    }
                }

                let coffeeCup = form.querySelector('.coffee-cup');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';

                    // For Livewire-bound fields, trigger input event to sync with wire:model
                    if (coffeeCup.hasAttribute('wire:model') || coffeeCup.hasAttribute('wire:model.defer')) {
                        coffeeCup.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }, delay);
        };

        // Initialize all existing honey forms
        document.querySelectorAll('.form--honey').forEach(form => {
            initHoneyForm(form);
        });

        // Watch for dynamically added forms
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // Check if the added node is a form with honey class
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('form--honey')) {
                            initHoneyForm(node);
                        }

                        // Also check for honey forms within the added node
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.form--honey').forEach(form => {
                                initHoneyForm(form);
                            });
                        }
                    }
                });
            });
        });

        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    partnerSlider() {
        document.querySelectorAll('.partners__list').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                autoplay: true,
                loop: true,
                breakpoints: {
                    0: {
                        spaceBetween: 60,
                        slidesPerView: 2,
                    },
                    500: {
                        spaceBetween: 60,
                        slidesPerView: 3,
                    },
                    576: {
                        spaceBetween: 60,
                        slidesPerView: 4,
                    },
                    768: {
                        spaceBetween: 60,
                        slidesPerView: 5,
                    },
                    992: {
                        spaceBetween: 60,
                        slidesPerView: 6,
                    },
                    1200: {
                        spaceBetween: 60,
                        slidesPerView: 6,
                    },
                    1400: {
                        spaceBetween: 90,
                        slidesPerView: 6
                    }
                },
                slidesPerGroup: 1
            });
        });
    }
}

window.addEventListener('load', () => new App());
